<template>
  <div class="quizset-main">
    <QuizsetButtonNew/>

    <div class="table">
      <div class="table-header">
        <div class="table-header-name">
          セット名
        </div>

        <div class="table-header-action">
          アクション
        </div>
      </div>

      <div
        v-for="(quizset, index) in quizsets"
        :key="index"
        class="table-cell"
        @click="editQuizset(quizset)"
        >

        <div class="table-cell-name">
          {{ quizset.get('name') }}
        </div>

        <div class="table-cell-action">
          <div class="icons">
            <icon-quiz :quizset="quizset" />
            <icon-copy :quizset="quizset" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import QuizsetButtonNew from '@/components/Quizset/ButtonNew'
import IconQuiz from '@/components/Quizset/IconQuiz'
import IconCopy from '@/components/Quizset/IconCopy'

export default {
  components: {
    QuizsetButtonNew,
    IconQuiz,
    IconCopy
  },

  computed: {
    ...mapState('quizset', [
      'quizsets'
    ])
  },

  methods: {
    editQuizset: function (quizset) {
      this.$router.push({
        name: 'quizset-edit',
        params: { id: quizset.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-name {
    padding: 5px;
    width: 85%;
  }

  &-action {
    padding: 5px;
    width: 15%;
  }
}

@import '@/styles/_table.scss';
@import '@/styles/_icon.scss';
</style>
